// extracted by mini-css-extract-plugin
export default {"block":"SectionAddAddendum_block__uW8vs","footer":"SectionAddAddendum_footer__1Xr8x","buttons":"SectionAddAddendum_buttons__83pwn"};